<template>
  <a-modal
    class="modal-content"
    title="预约心理老师"
    :width="650"
    :visible="visible"
    ok-text="保存"
    @ok="handleOk"
    @cancel="hideModal"
  >
    <template>
      <a-form-model ref="ruleForm" :model="form" :rules="rules">
        <a-form-model-item label="">
          <a-date-picker
            v-model="form.counselingDate"
            format="YYYY-MM-DD"
            style="width: 49%; margin-right: 2%"
          />
          <a-time-picker v-model="form.time" style="width: 49%" />
        </a-form-model-item>
        <a-form-model-item label="其他措施">
          <!--          <WangEditor-->
          <!--            v-model="form.comment"-->
          <!--            :editorStyle="{ minHeight: '200px' }"-->
          <!--            style="margin: 2px; border: 1px solid #d9d9d9; border-radius: 4px; overflow: hidden"-->
          <!--          />-->
          <a-textarea v-model="form.comment" :auto-size="{ minRows: 6, maxRows: 10 }" />
        </a-form-model-item>
      </a-form-model>
    </template>
  </a-modal>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
// import WangEditor from '@/components/WangEditor'
import { postAction } from '@api/manage'
import moment from 'moment'

export default {
  name: 'ReservePsychologyTeacher',
  mixins: [JeecgListMixin],
  components: {
    // WangEditor,
  },
  data() {
    return {
      visible: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 19 },
      form: {},
      modelType: '',
    }
  },
  methods: {
    showModal(record) {
      console.log('record记录', record)
      this.$set(this.form, 'id', record.id)
      this.visible = true
    },
    hideModal() {
      this.visible = false
      this.form = {}
    },
    async handleOk() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (!valid) return
        const params = {
          ...this.form,
          comment: '预约心理老师，' + this.form.comment || '',
          counselingDate: moment(this.form.counselingDate).format('YYYY-MM-DD'),
          warnStatus: 2,
          visible: 1,
        }
        const res = await postAction('/aigoes/schoolWarnRecord/warnProcess', params)
        if (res.success) {
          this.$message.success(res.message)
          console.log('表单数据：', params)
          this.hideModal()
          this.$emit('refreshData')
          return
        }
        this.$message.error(res.message)
      })
    },
  },
}
</script>
<style scoped lang="less">
.modal-content {
  /deep/ .ant-form-item {
    margin-bottom: 12px;
  }
}
</style>
